import React, { useContext, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import AppContext from 'context/Context';
import classNames from 'classnames';
import NavbarTop from 'components/navbar/top/NavbarTop';
import NavbarVertical from 'views/nav/components/NavbarVertical';
import Footer from 'components/footer/Footer';
import ProductProvider from 'components/app/e-commerce/ProductProvider';
import TrialBanner from 'components/common/TrialBanner';
import BackgroundNotificationsBridge from 'components/notifications/BackgroundNotificationsBridge';
import { NavCountsProvider } from 'context/NavCountsContext';
import AppJoyride from 'components/tour/AppJoyride';

const MainLayout = () => {
  const { hash, pathname } = useLocation();
  const isKanban = pathname.includes('kanban');
  const isMessages = pathname.startsWith('/messages');
  // const isChat = pathname.includes('chat');

  const {
    config: { isFluid, navbarPosition }
  } = useContext(AppContext);

  useEffect(() => {
    setTimeout(() => {
      if (hash) {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }
    }, 0);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <NavCountsProvider>
    <div className={isFluid ? 'container-fluid' : 'container'}>
      <AppJoyride />
      {(navbarPosition === 'vertical' || navbarPosition === 'combo') && (
        <NavbarVertical />
      )}
      <ProductProvider>
        <div
          data-tour="main-content"
          className={classNames('content', {
            'pb-0': isKanban || isMessages,
            'd-flex flex-column': isMessages
          })}
          style={isMessages ? { height: '100vh', overflow: 'hidden' } : undefined}
        >
          <BackgroundNotificationsBridge />
          <NavbarTop />
          <TrialBanner />
          {/*------ Main Routes ------*/}
          {isMessages ? (
            <div
              style={{ flex: '1 1 auto', minHeight: 0, overflow: 'hidden' }}
            >
              <Outlet />
            </div>
          ) : (
            <Outlet />
          )}
          {!isKanban && !isMessages && <Footer />}
        </div>
      </ProductProvider>
    </div>
    </NavCountsProvider>
  );
};

export default MainLayout;
